export enum PayMode {
    NONE = 0,
    CASH = 1,
    ONLINE = 2,
    CARD = 3,
    SODEXO = 4,
    CHEQUE = 5
}

export enum ReportGroupBy {
    PARTY,
    PRODUCT
}

export enum ReportTypes {
    DAILYSALES,
    INVOICE,
    BRAND,
    PARTYWISE,
    STOCK,
    STOCK_PURCHASE_HISTORY,
    GST,
    GSTPARTY,
    AUDIT_INVOICELIST,
    AUDIT_INVOICELIST_DETAIL
}

export enum DiscountType {
    AMOUNT,
    PERCENT
}
